import React from 'react';
import Navigation from '../components/Navigation';
import Footer from '../components/Footer';

const News = () => {
  const newsArticles = [
    {
      title: "We're Growing!",
      date: "Aug. 25, 2025",
      description: "We are excited to announce that Aliza Auces, MPH, has joined Onyx Rose Advisors as our new Director of Policy. Aliza brings extensive experience in Medicaid reimbursement and will help our clients navigate complex policy landscapes.",
      link: "/assets/press-releases/Welcome-Aliza-Auces.pdf",
    },
  ];

  return (
    <div>
      <Navigation />

      {/* Hero Section */}
      <section className="hero-section bg-gradient-to-br from-gray-900 via-onyx-900 to-gray-900">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            <h1 className="text-4xl sm:text-5xl md:text-6xl text-white mb-9">
              Stay Informed with Our Health Policy Insights
            </h1>
            <p className="text-xl text-white max-w-3xl mx-auto leading-relaxed">
              Providing expert perspectives on health policy, offering actionable insights, thought leadership, and the latest updates shaping the healthcare landscape.
            </p>
          </div>
        </div>
      </section>

      {/* News Articles Section */}
      <section className="py-24 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {newsArticles.map((article, index) => (
              <article
                key={index}
                className="bg-white rounded-lg shadow-lg hover:shadow-xl transition-all duration-300 overflow-hidden"
              >
                <div className="p-8">
                  <div className="text-sm text-accent font-semibold mb-3">
                    {article.date}
                  </div>
                  <h2 className="text-2xl font-bold text-gray-900 mb-4">
                    {article.title}
                  </h2>
                  <p className="text-gray-700 leading-relaxed mb-6">
                    {article.description}
                  </p>
                  {article.link && (
                    <a
                      href={article.link}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="inline-block text-accent font-semibold hover:text-accent-700 transition-colors duration-200"
                    >
                      Read more →
                    </a>
                  )}
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>

      {/* Newsletter Signup Section */}
      <section className="py-12 bg-gradient-to-br from-gray-900 via-onyx-900 to-gray-900">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-white mb-6">
            Subscribe to Our Newsletter
          </h2>
          <p className="text-lg sm:text-xl text-white leading-relaxed mb-10">
            Stay up to date with the latest health policy insights, news, and updates from Onyx Rose Advisors.
          </p>

          <form className="max-w-2xl mx-auto">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
              <div>
                <label htmlFor="firstName" className="sr-only">First Name</label>
                <input
                  type="text"
                  id="firstName"
                  name="firstName"
                  placeholder="First Name"
                  className="w-full px-4 py-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-accent focus:border-transparent"
                  required
                />
              </div>
              <div>
                <label htmlFor="lastName" className="sr-only">Last Name</label>
                <input
                  type="text"
                  id="lastName"
                  name="lastName"
                  placeholder="Last Name"
                  className="w-full px-4 py-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-accent focus:border-transparent"
                  required
                />
              </div>
            </div>
            <div className="mb-6">
              <label htmlFor="email" className="sr-only">Email Address</label>
              <input
                type="email"
                id="email"
                name="email"
                placeholder="Email Address"
                className="w-full px-4 py-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-accent focus:border-transparent"
                required
              />
            </div>
            <button
              type="submit"
              className="inline-block bg-accent text-white font-semibold px-10 py-4 rounded-md hover:bg-accent-900 transition-all duration-200 shadow-lg hover:shadow-xl text-lg"
            >
              Subscribe
            </button>
          </form>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default News;
